import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '../vue_widgets/chat_overview_widget.vue'

export default class extends Controller {

  static values = { inboxId: String }

  connect(context) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return
    console.log('chat overview widget controller connected.')

    const props = {
      inboxId: this.inboxIdValue
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
